export default "__VITE_ASSET__CDwMs5$t__"